import React from 'react';
import Bai from '../../img/uu2.png';
import Bic from '../../img/BIC.png';
import paulo from '../../img/paulo.png';
import network from '../../img/network.png';
import zefa from '../../img/zefa.png';
import Anemp from '../../img/Anemp.png';
import sonangoldc_logo from '../../img/sonangoldc_logo.png';
import pontes from '../../img/PONTES.png';
import blanto from '../../img/blanto.png';
import LARANJA from '../../img/LARANJA.png';
import rico from '../../img/rico.png';
import { Container, Row, Col, Carousel, Card, Nav } from 'react-bootstrap';
import './Clientes.css'; // Importe o arquivo CSS

const Clientes = () => {
    return (
        <section style={{ marginBottom: '190px' }}>
            {/* Topo da Section com "Clientes" e "e parceiros" */}
            <div className="mb-5">
                <Container>
                    <h2 className="text-center clientes-title">
                        <b>Clientes e parceiros</b>
                        <div className="underline"></div>
                    </h2>
                </Container>
            </div>

            <div className="clientes-section">
                {/* Cards com imagens */}
                <Container>
                    <Row className="d-flex justify-content-center" style={{ gap: '20px' }}>
                        <Carousel interval="2000">
                            {/* Primeiro Carrossel */}
                            <Carousel.Item>
                                <div className="d-flex justify-content-between">
                                    <div className="card-custom">
                                        <img src={pontes} className="card-img-top card-img-custom" alt="Card 1" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={zefa} className="card-img-top card-img-custom" alt="Card 2" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={LARANJA} className="card-img-top card-img-custom" alt="Card 3" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={network} className="card-img-top card-img-custom" alt="Card 4" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={Bai} className="card-img-top card-img-custom" alt="Card 5" />
                                    </div>
                                </div>
                            </Carousel.Item>
                            <Carousel.Item>
                                <div className="d-flex justify-content-between">
                                    <div className="card-custom">
                                        <img src={Bic} className="card-img-top card-img-custom" alt="Card 1" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={paulo} className="card-img-top card-img-custom" alt="Card 2" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={Anemp} className="card-img-top card-img-custom" alt="Card 3" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={sonangoldc_logo} className="card-img-top card-img-custom" alt="Card 4" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={blanto} className="card-img-top card-img-custom" alt="Card 5" />
                                    </div>
                                </div>
                            </Carousel.Item>
                            {/* Outros itens do carrossel */}
                        </Carousel>
                        <Carousel interval="2000">
                            {/* Primeiro Carrossel */}
                            <Carousel.Item>
                                <div className="d-flex justify-content-between">
                                    <div className="card-custom">
                                        <img src={rico} className="card-img-top card-img-custom" alt="Card 1" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={LARANJA} className="card-img-top card-img-custom" alt="Card 2" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={blanto} className="card-img-top card-img-custom" alt="Card 3" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={pontes} className="card-img-top card-img-custom" alt="Card 4" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={sonangoldc_logo} className="card-img-top card-img-custom" alt="Card 5" />
                                    </div>
                                </div>
                            </Carousel.Item>
                            <Carousel.Item>
                                <div className="d-flex justify-content-between">
                                    <div className="card-custom">
                                        <img src={Anemp} className="card-img-top card-img-custom" alt="Card 1" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={zefa} className="card-img-top card-img-custom" alt="Card 2" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={network} className="card-img-top card-img-custom" alt="Card 3" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={paulo} className="card-img-top card-img-custom" alt="Card 4" />
                                    </div>
                                    <div className="card-custom">
                                        <img src={Bic} className="card-img-top card-img-custom" alt="Card 5" />
                                    </div>
                                </div>
                            </Carousel.Item>
                            {/* Outros itens do carrossel */}
                        </Carousel>
                    </Row>
                </Container>
            </div>

            <div id="contacto"></div>
        </section>
    );
};

export default Clientes;
